<template>
  <vx-card class="mt-2">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="1">DISPOSIÇÕES GERAIS</th>
      </tr>
      <tr>
        <td class="pl-2 pr-2" style="text-align: justify">
          <div
            style="text-align: justify"
            class="pl-3 pt-3"
            v-html="customSectionsMsgs.GENERAL_PROVISIONS"
          ></div>
        </td>
      </tr>
      <div v-if="isQuotation" class="mt-5 flex justify-end">
        <vs-button
          color="success"
          type="gradient"
          class="w-2/6 btn-print"
          @click="printPdf()"
        >
          Exportar PDF
        </vs-button>
      </div>
    </table>
  </vx-card>
</template>

<script>
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractGeneralProvisions',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
    };
  },
  methods: {
    printPDF() {
      window.print();
    },
  },
};
</script>
